import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomRadioButtonComponent } from './custom-radio-button.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';


@NgModule({
  declarations: [
    CustomRadioButtonComponent
  ],
  imports: [
    CommonModule,    
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule
  ],
  exports:[
    CustomRadioButtonComponent
  ]
})
export class CustomRadioButtonModule { }
